import { Flex, View } from "@adobe/react-spectrum";
import CallDialPad from "../CallDialer/CallDialpad";

const DtmfDialog = () => {
  return (
    <Flex
      width={"100%"}
      alignItems={"center"}
      justifyContent={"center"}
      UNSAFE_className="dialer-container"
    >
      <View paddingTop={"1rem"} paddingBottom={"1rem"}>
        <CallDialPad callType ="dtmf" />
      </View>
    </Flex>
  );
};

export default DtmfDialog;
